import Image from "next/image";
import InlineButton from "./inline-button";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

export interface ImageTextCardProps {
  className?: string;
  align?: "left" | "right" | "center";
  image?: {
    src: string | StaticImport;
    alt: string;
  };
  imageParentClassName?: string;
  imageClassName?: string;
  title?: string;
  titleClassName?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  cta?: {
    className?: string;
    href: string;
    text: string | React.ReactNode;
    prefetch?: boolean;
  };
}

const ImageTextCard: React.FC<ImageTextCardProps> = ({
  className = "",
  align = "center",
  image,
  imageParentClassName = "",
  imageClassName = "",
  title,
  titleClassName,
  contentClassName = "",
  children,
  cta = {
    className: "",
    href: "#",
    text: "Learn More",
    prefetch: true,
  },
}) => {
  return (
    <div
      className={cn(
        "flex w-fit flex-col overflow-hidden rounded-lg bg-white md:rounded-2xl",
        "border-[0.63px] border-neutral-100 shadow-[0px_3.77px_12.58px_0px_rgba(49,45,44,0.1)] md:shadow-[4px_8px_24px_2px_rgba(82,77,75,0.1)]",
        className
      )}
    >
      {image && (
        <div className={cn("relative overflow-clip", imageParentClassName)}>
          <Image
            className={cn("left-0 right-0 top-0 flex", imageClassName)}
            style={{
              objectFit: "cover",
              scale: "112%",
              objectPosition: "center top",
            }}
            fill
            src={image.src}
            alt={image.alt}
          />
        </div>
      )}
      <div
        data-testid="content-container"
        className={cn(
          "flex flex-col bg-white p-5 pt-6",
          align === "left" && "items-start text-start",
          align === "right" && "items-end text-end",
          align === "center" && "items-center text-center",
          contentClassName
        )}
      >
        {title && (
          <h3
            className={cn(
              "text-subheading-3-600 w-full font-montserrat",
              titleClassName
            )}
          >
            {title}
          </h3>
        )}
        {children}
        <InlineButton
          className={cn(cta.className)}
          color="gray"
          size="sm"
          asChild
        >
          <Link
            href={cta.href}
            prefetch={cta.prefetch}
          >
            {cta.text}
          </Link>
        </InlineButton>
      </div>
    </div>
  );
};

export default ImageTextCard;
